import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import logo from 'assets/img/logo.png';
import 'assets/scss/landingPage.css';
import StepIndicator from 'components/transactions/StepsIndicator';
import {
  TRIAL_SIGNUP_ROUTES,
  RENEW_SUBSCRIPTION_ROUTES,
} from 'constants/Routes';
import {
  FREE_SIGNUP_STEPS,
  RENEW_SUBSCRIPTION_STEPS,
} from 'constants/Transactions';
import {
  getContactDetails,
  getBusinessDetails,
  getToken,
  getOnboardingStatus,
  getBusinessId,
  getSelectedPlan,
} from 'constants/localStorageManager';
import CircularStepIndicator from 'components/transactions/CircularStepsIndicator';

class SignUpWrapper extends Component {
  componentDidMount() {
    const { renew } = this.props;
    if (renew) this.handleRenewRoute();
    else this.handleRoute();
  }

  handleRenewRoute = () => {
    if (!getToken()) return this.props.history.push('/');
    if (!getSelectedPlan()) {
      this.props.history.push(RENEW_SUBSCRIPTION_ROUTES.SELECT_PLANS);
    }
  };

  handleRoute = () => {
    const { currentStep } = this.props;
    const token = getToken();
    const onboardingStatus = getOnboardingStatus() || {};
    const signupContactDetails = getContactDetails();
    const businessDetails = getBusinessDetails();

    if (!signupContactDetails && !token) {
      const pushUrl = TRIAL_SIGNUP_ROUTES.CONTACT_DETAILS;
      if (currentStep !== pushUrl) return this.props.history.push(pushUrl);
      return;
    }
    if (token) {
      // return this.props.history.push(TRIAL_SIGNUP_ROUTES.PAYMENT_DETAILS);
      if (onboardingStatus.completed || getBusinessId()) {
        return this.props.history.push('/');
      }
      if (
        (signupContactDetails && !businessDetails) ||
        !onboardingStatus.completed
      ) {
        const pushUrl = TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS;
        if (currentStep !== pushUrl) return this.props.history.push(pushUrl);
      }
    }
  };

  render() {
    const { step, currentStep, renew } = this.props;

    const STEPS_LIST = renew ? RENEW_SUBSCRIPTION_STEPS : FREE_SIGNUP_STEPS;

    const currentStepObj = STEPS_LIST.find(step => step.path == currentStep);
    const currentStepNumber = STEPS_LIST.indexOf(currentStepObj);

    return (
      <div>
        <header className="header inner-header">
          <div className="navbar navbar-dark">
            <div className="container d-flex justify-content-between">
              <a
                href="/home"
                className="navbar-brand d-flex align-items-center"
              >
                <img src={logo} title="Soono Logo" alt="Soono Logo" />
              </a>
            </div>
          </div>
        </header>
        <div className="container-fluid">
          <div className="row justify-content-md-center">
            <div className="col-lg-3 col-md-5 col-sm-12 bg-light py-lg-3 py-3 px-lg-5 px-0 mt-0">
              <CircularStepIndicator
                activeStepNumber={currentStepNumber}
                steps={STEPS_LIST}
              />
              <ul className="trial-signup-steps pt-4">
                {STEPS_LIST.map(({ path, stepName }, index) => (
                  <StepIndicator
                    step={path}
                    stepName={stepName}
                    link={path}
                    currentStep={currentStep}
                    activeStepNumber={currentStepNumber}
                    currentStepNumber={index}
                  />
                ))}
                <li>
                  <div
                    className={`node ${step === 5 ? 'active-menu-node' : null}`}
                  >
                    <FontAwesomeIcon
                      icon="rocket"
                      className="text-white steps-icon laucnh-icon"
                    />
                  </div>
                  <NavLink
                    onClick={e => {
                      e.preventDefault();
                    }}
                    className="text"
                    exact
                    activeClassName="active-menu"
                    to="/"
                  >
                    {renew ? 'Complete Payment' : 'Launch Survey'}
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col-lg-9 col-md-7 col-sm-12 text-center bg-white">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignUpWrapper);



// WEBPACK FOOTER //
// ./src/containers/SignUpWrapper.js